@if (title) {
  <div class="flex-container-row" style="justify-content: space-between; height: 65px">
    <span style="margin: 20px">
  <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
    </span>
    <div class="draw-container">
      @for (button of buttons; track $index) {
        <vl-big-button [text]="button.text"
                       (click)="buttonAction.emit($index)"></vl-big-button>
      }
    </div>
  </div>
}
@if (!new()) {
  <ng-content select='.justup-page-header'>
  </ng-content>
}
@if (!new()) {
  <div class="flex-container-row">
    <div class="filter-content">
      <div class="justup-card">
        <ng-container *ngTemplateOutlet="filterTemplate"></ng-container>
      </div>
    </div>
    <div class="flex-container" style="width: 100%;">
      <div class="filter-button">
        <vl-big-button
          [text]="'filters.label' | trans"
          [icon]="'filter_alt'"
          (action)="filterAction.emit()"
        ></vl-big-button>
      </div>

      <div class="page-content">
        <ng-container *ngTemplateOutlet="pageTemplate"></ng-container>
      </div>
    </div>
  </div>
}

@if (new()) {
  <div class="top-content w100 justify-center flex-row gap-32 mt-4 border-box pb-4">
    <div class="gap-16 flex-col w100 border-box"
         [ngClass]="{'small-page': type() === 'small' && !aside(), 'px-md-32': type() === 'large' || aside()}">
      <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
      <ng-container *ngTemplateOutlet="filterTemplate"></ng-container>
      @if (aside() && staticAside() && displayService.isLd()) {
        <ng-container *ngTemplateOutlet="asideTemplate"></ng-container>
      }
    </div>
  </div>
  <div #mainContent class="main-content overflow-scroll w100 flex-col relative border-box justup-page-main-content">
    <div class="w100 gradient-scroll-top"></div>
    <div class="flex-row w100 gap-32 border-box scroll-content"
         [ngClass]="{'justify-center': !aside()}">
      <div class="flex-row h100 grow justify-center max-w-100"
           [ngClass]="{'max-width-aside': aside() && !displayService.isLd()}">
        <div class="gap-16 flex-col h100 w100"
             [ngClass]="{'small-page': type() === 'small'}">
          @if (aside() && displayService.isLd() && !staticAside()) {
            <ng-container *ngTemplateOutlet="asideTemplate"></ng-container>
          }
          <ng-container *ngTemplateOutlet="pageTemplate"></ng-container>
        </div>
      </div>
      @if (aside() && !displayService.isLd()) {
        <div class="justup-page-aside">
          <div [ngClass]="{'aside-sticky': staticAside()}">
            <ng-container *ngTemplateOutlet="asideTemplate"></ng-container>
          </div>
        </div>
      }
    </div>
  </div>
}
<ng-template #titleTemplate>
  <ng-content select='.justup-page-title'>
  </ng-content>
</ng-template>

<ng-template #filterTemplate>
  <ng-content select='.justup-page-filter'>
  </ng-content>
</ng-template>

<ng-template #pageTemplate>
  <ng-content select='.justup-page-content'>
  </ng-content>
</ng-template>

<ng-template #asideTemplate>
  <ng-content select='.justup-page-aside'>
  </ng-content>
</ng-template>
